import { firestoreDB } from './firebase';

const CRUDCount = async function CRUDCount(resourceName, field, value) {
  const count = await firestoreDB.collection(`${process.env.ENV_SHORTNAME}_cruds`).doc('list').collection(resourceName).where(field, '==', value)
    .get()
    .then((querySnapshot) => querySnapshot.size)
    .catch((error) => {
      console.log('Error getting documents: ', error);
    });
  return count;
};

const CRUDCreate = async function CRUDCreate(resourceName, content) {
  const object = content;
  const count = await CRUDCount(resourceName, 'name', content.name);

  if (count > 0) {
    return { error: true, errorMessage: 'the resource already exist' };
  }
  const docRef = firestoreDB.collection(`${process.env.ENV_SHORTNAME}_cruds`).doc('list').collection(resourceName).doc();
  object.id = docRef.id;

  await docRef.set(object)
    .then(() => {
      console.log('Document successfully created!');
      return content;
    })
    .catch((error) => {
      console.error('Error creating document: ', error);
    });

  return object;
};
const CRUDUpdate = async function CRUDUpdate(resourceName, resourceId, content) {
  let existAlready = false;
  await firestoreDB.collection(`${process.env.ENV_SHORTNAME}_cruds`).doc('list').collection(resourceName).where('name', '==', content.name)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        if (doc.id !== resourceId) {
          existAlready = true;
        }
      });
    })
    .catch((error) => {
      console.log('Error getting documents: ', error);
    });

  if (existAlready) {
    return { error: true, errorMessage: 'A resource with the same value already exist' };
  }

  await firestoreDB.collection(`${process.env.ENV_SHORTNAME}_cruds`).doc('list').collection(resourceName).doc(resourceId)
    .set(content)
    .then(() => {
      console.log('Document successfully updated!');
      return false;
    })
    .catch((error) => {
      console.error('Error updating document: ', error);
      return { error: true, errorMessage: 'Error updating document' };
    });
};
const CRUDDelete = async function CRUDDelete(resourceName, resourceId) {
  const deleted = await firestoreDB.collection(`${process.env.ENV_SHORTNAME}_cruds`).doc('list').collection(resourceName).doc(resourceId)
    .delete()
    .then(() => {
      console.log('Document successfully deleted!');
      return true;
    })
    .catch((error) => {
      console.error('Error removing document: ', error);
    });

  return deleted;
};

const CRUDGetAll = async function CRUDGetAll(resourceName) {
  const resources = [];
  const items = await firestoreDB.collection(`${process.env.ENV_SHORTNAME}_cruds`).doc('list').collection(resourceName).get();
  items.docs.forEach((doc) => {
    const current = doc.data();
    current.id = doc.id;
    resources.push(current);
  });

  return resources;
};

export {
  CRUDGetAll, CRUDCreate, CRUDUpdate, CRUDDelete,
};



// WEBPACK FOOTER //
// ./src/assets/js/CRUDFirestore.js